import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=560bf388&scoped=true&"
var script = {}
import style0 from "./Error404.vue?vue&type=style&index=0&id=560bf388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560bf388",
  null
  
)

export default component.exports